export default {
  ROOT: 1,
  ADMINISTRADOR: 2,
  USUARIO: 3
}
